export const replacePlaceholders = (text: string, replacements: Record<string, string>) => {
    return text.replace(/{{(.*?)}}/g, (match, placeholder) => {
        return replacements[placeholder] || match
    })
}
